import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import ResetPrasadSection from "../components/ResetPrasad/ResetPrasad";
import { usePageLogger } from "../hooks/usePageLogger";

const ResetPrasadPage = () => {
  const { user } = useSelector((state) => state.auth);
  usePageLogger("ResetPrasad Page", {
    username: user?.username,
    role: user?.role,
  });

  return (
    <>
      <Box>
        <Typography variant="h4" gutterBottom>
          Reset Prasad for all donors
        </Typography>
        <ResetPrasadSection username={user?.username} role={user?.role} />
      </Box>
    </>
  );
};

export default ResetPrasadPage;
